/**
 * containsUnencryptedSecretFields
 *
 * Scans a markdown content string for `::secret[…]{…}::` directives and
 * returns `true` if any of them hold plaintext content (i.e. content that
 * does NOT start with the `enc:` prefix).
 *
 * Used by the save guard to prevent accidental plaintext persistence when the
 * note is expected to be encrypted (has a key wrapper).
 */

import { isEncryptedFieldValue } from '@/services/CryptoService'

/**
 * Regex that matches the content portion of an inline secret directive:
 *   ::secret[optional label]{<content>}::
 *
 * Capture group 1 = the content string inside {…}.
 * Uses a non-greedy match so multiple fields on one line are handled correctly.
 */
const SECRET_FIELD_CONTENT_RE = /::secret\[[^\]]*]\{(.*?)}::/g

/**
 * Return `true` if `content` contains at least one secret field whose value
 * is **not** encrypted.
 *
 * @param content - Full markdown content string.
 */
export function containsUnencryptedSecretFields(content: string): boolean {
    SECRET_FIELD_CONTENT_RE.lastIndex = 0
    let match: RegExpExecArray | null

    while ((match = SECRET_FIELD_CONTENT_RE.exec(content)) !== null) {
        const fieldContent = match[1]
        if (!isEncryptedFieldValue(fieldContent)) {
            return true
        }
    }

    return false
}


